<template>
    <div class="list-container">
        <div class="list-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
        </div>

        <div class="list-content-div">
            <div class="list-header-title-div">对账信息管理</div>

            <div class="list-content-header">
                <div class="list-content-card">
                    <p class="list-card-tit">平台实际金额总计</p>
                    <p class="list-card-num">{{ pageInfo.allTActFee || 0 }}元</p>
                </div>
                <div class="list-content-card">
                    <p class="list-card-tit">财付通金额总计</p><!-- 流水金额 -->
                    <p class="list-card-num">{{ pageInfo.allInExpAmount || 0 }}元</p>
                </div>
                <div class="list-content-card">
                    <p class="list-card-tit">不匹配金额总计</p>
                    <p class="list-card-num">{{ pageInfo.nOrderFee || 0 }}元</p>
                </div>
                <div class="list-content-card">
                    <p class="list-card-tit">异常金额总计</p>
                    <p class="list-card-num">{{ pageInfo.abnormalFee || 0 }}元</p>
                </div>
                <!-- <div class="list-content-card">
                    <p class="list-card-tit">钱包消费金额总计</p>
                    <p class="list-card-num">{{ pageInfo.walletFee || 0 }}元</p>
                </div> -->
            </div>

            <ZD-list-querys>
                <template slot="inputs">
                    <!-- <div class="list-query-child-div flex">
                        <div class="query-title-div">运营商</div>
                        <div class="query-inputs-div flex-1">
                            <el-select size="small" v-model="queryInfo.corpNo" clearable class="full-width">
                                <el-option v-for="(item, index) in []" :key="index" :value="item.configName">{{ item.configName }}</el-option>
                            </el-select>
                        </div>
                    </div> -->
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">站点名称</div>
                        <div class="query-inputs-div flex-1">
                            <el-select size="small" v-model="queryInfo.stationNo" filterable clearable class="full-width">
                                <el-option
                                    v-for="item in selectListObj.stationList"
                                    :key="item.id"
                                    :value="item.stationNo"
                                    :label="item.stationName"
                                />
                            </el-select>
                        </div>
                    </div>
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">是否匹配</div>
                        <div class="query-inputs-div flex-1">
                            <el-select size="small" v-model="queryInfo.orderFlag" class="full-width">
                                <el-option :value="'Y'" label="是"></el-option>
                                <el-option :value="'N'" label="否"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <!-- <div class="list-query-child-div flex">
                        <div class="query-title-div">是否异常</div>
                        <div class="query-inputs-div flex-1">
                            <el-select size="small" v-model="queryInfo.isAbnormal" class="full-width">
                                <el-option :value="'Y'" label="是"></el-option>
                                <el-option :value="'N'" label="否"></el-option>
                            </el-select>
                        </div>
                    </div> -->
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">模糊查询</div>
                        <div class="query-inputs-div flex-1">
                            <el-input size="small" v-model="queryInfo.orderNo" placeholder="请输入订单编号/微信订单号" clearable @keyup.enter.native="handleSearch"></el-input>
                        </div>
                    </div>
                </template>
                <template slot="actions">
                    <div>
                        <button class="common-bg-button" @click="handleSearch">搜 索</button>
                        <button class="common-empty-button" @click="handleReset">重 置</button>
                    </div>
                </template>
            </ZD-list-querys>

            <div class="list-actions">
                <button class="common-bg-button" @click="handleShowUpload">导入数据</button>
                <button class="common-bg-button" @click="handleShowHistory">历史数据</button>
                <button class="common-bg-button" @click="handleExport">导出数据</button>
            </div>

            <p class="accounts-title">任务名称：{{ taskInfo.taskName }} <br/> 创建月份：{{ taskInfo.createdWhen ? $D.format(taskInfo.createdWhen, 'Y年M月') : '' }}</p>

            <el-tabs class="account-tabs" v-model="queryInfo.isAbnormal" @tab-click="handleAbnormal">
                <el-tab-pane label="正常订单" name="N"></el-tab-pane>
                <el-tab-pane label="异常订单" name="Y"></el-tab-pane>
            </el-tabs>

            <!-- 表格 -->
            <div class="list-table">
                <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData" :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="(sels) => {selections = sels;}"></ZD-table>
            </div>

            <!-- 分页 -->
            <div class="list-pagination">
                <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
            </div>

            <!-- 导入数据 -->
            <el-dialog
                title="上传"
                width="500px"
                :show-close="false"
                :lock-scroll="true"
                :visible.sync="uploadDialog.show"
                v-loading="uploadDialog.loading"
            >
                <!-- 上传文件 -->
                <el-form
                    :model="uploadDialog.formInfo"
                    :rules="uploadDialog.rules"
                    ref="formForm"
                    label-width="120px"
                    class="dialog-form"
                >
                    <el-form-item label="任务名称" prop="taskName">
                        <el-input
                            v-model="uploadDialog.formInfo.taskName"
                            placeholder="请输入任务名称"
                            size="small"
                            class="dialog-item"
                            clearable
                        />
                    </el-form-item>
                    <el-form-item label="选择月份" prop="orderChargeMonth">
                        <el-date-picker
                            v-model="uploadDialog.formInfo.orderChargeMonth"
                            placeholder="请选择月份"
                            format="yyyy-MM"
                            value-format="yyyy-MM"
                            type="month"
                            size="small"
                            class="dialog-item"
                        />
                    </el-form-item>
                    <el-form-item label="上传文件" prop="file">
                        <el-upload
                            action="#"
                            accept=".xls,.xlsx,.csv"
                            :limit="1"
                            :file-list="uploadDialog.fileList"
                            :on-exceed="handleExceed"
                            :before-upload="handleBeforeUpload"
                            :http-request="handleRequest"
                            :on-remove="handleRemove"
                        >
                            <el-button size="small" type="primary">上传文件</el-button>
                            <div slot="tip" class="el-upload__tip">上传文件格式为xls,xlsx,csv</div>
                        </el-upload>
                    </el-form-item>
                </el-form>
                
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" size="small" plain @click="handleCancel">取 消</el-button>
                    <el-button type="primary" size="small" @click="handleOver('formForm')">提 交</el-button>
                </div>
            </el-dialog>

            <!-- 历史数据 -->
            <el-dialog
                title="历史数据"
                width="950px"
                :show-close="false"
                :lock-scroll="true"
                :visible.sync="historyDialog.show"
                v-loading="historyDialog.loading"
            >
                <div class="dialog-actions">
                    <span class="dialog-actions-label">选择月份</span>
                    <el-date-picker
                        v-model="historyDialog.queryInfo.selectDate"
                        @change="handleSelectData"
                        placeholder="请选择月份"
                        format="yyyy-MM"
                        value-format="yyyy-MM"
                        type="month"
                        size="small"
                    />
                </div>
                <el-table
                    ref="listTableRef"
                    class="dialog-table"
                    :data="historyDialog.list"
                    :stripe="true"
                    border
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column type="index" width="55" align="center"></el-table-column>
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column prop="taskName" label="任务名称" min-width="160" align="center"></el-table-column>
                    <el-table-column prop="taskTypeName" label="状态" min-width="160" align="center"></el-table-column>
                    <el-table-column prop="version" label="版本名" min-width="200" align="center"></el-table-column>
                    <el-table-column prop="createdWhen" label="匹配时间" min-width="160" align="center"></el-table-column>
                    <el-table-column label="操作" min-width="100" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleCheck(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="dialog-pagination">
                    <el-pagination
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="historyDialog.pagination.current"
                        :page-sizes="historyDialog.pagination.pageSizes"
                        :page-size="historyDialog.pagination.pageSize"
                        :total="historyDialog.pagination.total"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                    ></el-pagination>
                </div>

                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" size="small" plain @click="historyDialog.show = false">取 消</el-button>
                    <!-- <el-button type="primary" size="small" @click="handleCheck">查 看</el-button> -->
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import pageConfig from './page-config'

export default {
    data () {
        return {
            pageConfig: pageConfig, // 页面配置
            pageInfo: {},
            taskInfo: {
                taskName: '',
                createdWhen: ''
            },
            tableData: [], // 表格数据
            selections: [], // 表格选项
            pagination: pageConfig.pagination,
            queryInfo: {
                isAbnormal: 'N',
                orderFlag: 'Y',
                stationNo: '',
                orderNo: ''
            },
            operates: {
                width: 150,
                fixed: 'right',
                list: []
            },
            selectListObj: {
                stationList: []
            },
            uploadDialog: {
                show: false,
                loading: false,
                formInfo: {
                    taskName: '',
                    orderChargeMonth: '',
                    file: '',
                },
                rules: pageConfig.rules,
                fileList: [],
            },
            historyDialog: {
                show: false,
                loading: false,
                queryInfo: {
                    corpNo: this.$store.state.corpNo,
                    selectDate: null
                },
                pagination: {
                    current: 1,
                    total: 0,
                    pageSize: 10,
                    pageSizes: [10, 20, 50, 100],
                },
                multipleSelection: [],
                list: []
            }
        }
    },
    methods: {
        /* 初始化 */
        init () {
            this.initData()
            this.initSelectListObj()
        },

        /* 初始化数据 */
        initData () {
            let _ = this
            _.$U.showLoading(_)
            _.$H.post(_, _.$A.reconciliationTask.findByCorpNo, { corpNo: _.$store.state.corpNo }).then((res) => {
                _.pageInfo = res.data.data;
                _.taskInfo = {
                    taskName: _.pageInfo.taskName,
                    createdWhen: _.pageInfo.createdWhen
                }
                if (res.data.data.taskNo) {
                    _.queryInfo.taskNo = res.data.data.taskNo
                    _.getListData(_.pageConfig.pagination)
                }
                _.$U.hideLoading(_)
            })
        },
        
        /* 获取表格数据 */
        getListData(pagination, reload = false) {
            let _ = this
            _.$U.showLoading(_)
            _.queryInfo.pageNum = pagination.current - 1
            if (reload) {
                this.pagination.current = 1
                _.queryInfo.pageNum = 0
            }
            _.queryInfo.pageSize = pagination.pageSize
            _.$H.post(_, _.$A.reconciliation.page, _.queryInfo).then((res) => {
                _.tableData = res.data.data.content || []
                _.pagination.total = res.data.data.totalElements || 0
                // _.taskInfo = {
                //     taskName: _.tableData[0].taskName,
                //     createdWhen: _.tableData[0].createdWhen
                // }
                _.$U.hideLoading(_)
            })
        },

        /* 获取历史数据 */
        initHistoryData (pagination) {
            let _ = this
            this.historyDialog.loading = true
            this.historyDialog.queryInfo.pageNum = pagination.current - 1
            this.historyDialog.queryInfo.pageSize = pagination.pageSize
            this.$H.post(_, _.$A.reconciliationTask.page, _.historyDialog.queryInfo).then((res) => {
                _.historyDialog.list = res.data.data.content || []
                _.historyDialog.pagination.total = res.data.data.totalElements || 0
                _.historyDialog.loading = false
            })
        },

        initSelectListObj () {
            let _ = this
            this.$H.post(_, _.$A.pilestation.list, { corpNo: _.$store.state.corpNo }).then((res) => {
                _.selectListObj.stationList = res.data.data
            })
        },

        /* 搜索 */
        handleSearch () {
            this.pageConfig.pagination.current = 1
            this.getListData(this.pageConfig.pagination)
        },

        /* 重置 */
        handleReset () {
            this.queryInfo.isAbnormal = 'N'
            this.queryInfo.orderFlag = 'Y'
            this.queryInfo.stationNo = ''
            this.queryInfo.orderNo = ''
            this.pageConfig.pagination.current = 1
            this.initData()
        },

        /* 导入数据 */
        handleShowUpload () {
            this.uploadDialog.show = true
        },

        /* 历史数据 */
        handleShowHistory () {
            this.historyDialog.pagination.current = 1
            this.initHistoryData(this.historyDialog.pagination)
            this.historyDialog.show = true
        },

        /* 导出 */
        handleExport () {
            let _ = this,
                queryInfo = {
                    taskNo: _.queryInfo.taskNo,
                    isAbnormal: _.queryInfo.isAbnormal,
                    orderFlag: _.queryInfo.orderFlag,
                    stationNo: _.queryInfo.stationNo,
                    orderNo: _.queryInfo.orderNo,
                };
            
            this.$H.post(_, _.$A.reconciliation.reconciliationExport, queryInfo).then((res) => {
                window.open(res.data.data.filePath, '_blank')
            })
        },

        /* 是否异常 */
        handleAbnormal (e) {
            this.queryInfo.orderFlag = this.queryInfo.isAbnormal == 'Y' ? 'N' : 'Y'
            this.handleSearch()
        },

        /* 完成 */
        handleOver (formName) {
            let _ = this;
            this.$refs[formName].validate(async (valid) => {
                if (!valid) return
                _.uploadDialog.loading = true

                const { data: flagRes } = await _.$H.post(_, _.$A.reconciliationTask.findFlag, {})
                if (!flagRes.data.taskFlag) {
                    _.$U.error('其他任务对账中，请稍后上传！');
                    _.uploadDialog.loading = false
                    return
                }

                let formData = new FormData();
                Object.keys(this.uploadDialog.formInfo).forEach((key) => {
                    formData.append(key, _.uploadDialog.formInfo[key]);
                });
                const { data: res } = await _.$H.post(_, _.$A.reconciliationTask.add, formData)
                _.uploadDialog.loading = false
                if (res.status == 200) {
                    _.$U.success('后台对账中，请到历史数据中查看结果！');
                    _.handleCancel()
                    _.handleReset()
                }
                // _.$H.post(_, _.$A.reconciliationTask.add, formData).then((res) => {
                //     _.uploadDialog.loading = false
                //     if (res.data.status == 200) {
                //         _.handleCancel()
                //         _.handleReset()
                //     }
                // })
            })
        },

        /* 重置 */
        handleCancel () {
            this.uploadDialog.formInfo = {
                taskName: '',
                orderChargeMonth: '',
                file: '',
            }
            this.uploadDialog.fileList = []
            this.$refs.formForm.resetFields()
            this.uploadDialog.show = false
        },

        /* 限制文件数量 */
        handleExceed (files, fileList) {
            this.$message.warning('当前限制' + fileList.length + '个文件')
        },

        /* 限制文件大小 */
        handleBeforeUpload (file) {
            let isLt15M = file.size / 1024 / 1024 / 15 < 1
            if (!isLt15M) {
                this.$message.error('上传文件大小不能超过15M!')
                return false
            }
        },

        /* 上传数据 */
        handleRequest (response) {
            this.uploadDialog.formInfo.file = response.file
            this.uploadDialog.fileList = [response.file]
            this.$refs.formForm.clearValidate('file')
        },

        /* 移出数据 */
        handleRemove (file, fileList) {
            this.uploadDialog.formInfo.file = ''
            this.uploadDialog.fileList = fileList
        },
        
        /* 历史数据 —— 选择月份 */
        handleSelectData (e) {
            this.historyDialog.pagination.current = 1;
            this.initHistoryData(this.historyDialog.pagination)
        },

        /* 历史数据 —— 查看 */
        // handleCheck () {
        //     if (!this.checkSelectOne()) return
        //     this.queryInfo.taskNo = this.historyDialog.multipleSelection[0].taskNo
        //     this.taskInfo = {
        //         taskName: this.historyDialog.multipleSelection[0].taskName,
        //         createdWhen: this.historyDialog.multipleSelection[0].createdWhen
        //     }
        //     this.getListData(this.pageConfig.pagination)
        //     this.historyDialog.show = false
        // },
        // .taskType, scope.row.taskNo, scope.row.taskName, scope.row.createdWhen
        handleCheck (row) {
            if (row.taskType == '02') {
                this.$U.error('对账中，请稍后查看！');
                return
            }

            this.queryInfo.taskNo = row.taskNo
            this.taskInfo = {
                taskName: row.taskName,
                createdWhen: row.createdWhen
            }
            this.getListData(this.pageConfig.pagination)
            this.historyDialog.show = false
        },

        /* 选择列表 */
        handleSelectionChange (val) {
            this.historyDialog.multipleSelection = val
        },

        checkSelectOne () {
            if (this.historyDialog.multipleSelection.length < 1) {
                this.$U.error('请选择需要操作的对象');
                return false;
            }
            if (this.historyDialog.multipleSelection.length > 1) {
                this.$U.error('只能选择一个操作的对象');
                return false;
            }
            return true;
        },

        handleSizeChange(e){
            this.historyDialog.pagination.pageSize = e;
            this.historyDialog.pagination.current = 1;
            this.initHistoryData(this.historyDialog.pagination)
        },
        handleCurrentChange(e){
            this.historyDialog.pagination.current = e;
            this.initHistoryData(this.historyDialog.pagination)
        },
    },
    mounted () {
        this.init()
    }
}
</script>

<style lang="less" scoped>
    .list-content-header {
        width: calc(100% + 20px);
        margin-left: -10px;
        padding: 32px 0 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;

        .list-content-card {
            min-width: 232px;
            margin: 10px;
            background: #ffffff;
            box-shadow: 0px -1px 16px 0px rgba(42, 42, 68, 0.1);
            border-radius: 22px;
            text-align: center;
            flex: 1;

            .list-card-tit {
                margin: 20px 30px;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #8f9bb3;
                line-height: 16px;
            }

            .list-card-num {
                padding: 20px 22px;
                font-size: 12px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #000000;
                line-height: 32px;
            }
        }
    }

    .list-actions {
        margin-bottom: 24px;
    }

    .dialog-item {
        width: 220px;
    }

    .dialog-steps {
        margin-bottom: 24px;
    }

    .dialog-tips {
        margin-bottom: 24px;

        span.error {
            color: #FF0000;
        }
    }

    .dialog-over {
        text-align: center;
    }

    .dialog-actions {
        margin-bottom: 24px;
        .dialog-actions-label {
            margin-right: 12px;
        }
    }

    .dialog-pagination {
        margin-top: 16px;
        text-align: center;
    }

    .accounts-title {
        line-height: 40px;
        margin: 0;
        padding: 20px 0;
        font-size: 20px;
        font-weight: 600;
        color: #000;
    }

    .account-tabs {
        margin-bottom: 10px;
        /deep/ .el-tabs__nav-wrap::after {
            display: none;
        }
    }
</style>
